import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, Input,OnInit } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { AdditionalInfoService } from '@app/_core/services/additional-info.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfigService } from '@app/config.services';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal'; 
import{NotesHelper} from '@app/_core/helper/NotesHelper';
@Component({
  selector: 'app-member-information',
  templateUrl: './member-information.component.html',
  styleUrl: './member-information.component.scss'
})

export class MemberInformationComponent implements OnInit,AfterViewInit{

  displayMemberInfo:boolean=false
  sortOrder='Asc';
  maxdate:Date=new Date()
  modalRef:BsModalRef;
  User:any;
  Company:any;
  @Input() FieldsConf:any;
  @Input() ReadOnly:boolean;
  memberSearchData:MemberSearch;
  MemberData: any=[];
  currentpage=0;
  MemberName:string='';
  showTabularData: boolean=false;
  fieldDetails: any[]=[];
  mappedDetails: any={};
  
  constructor(private http: HttpClient, private modalService: BsModalService,
    private webStorageService: WebStorageService,
    private loaderService:LoaderService,
     private configService:ConfigService,
     private additionalinfoService:AdditionalInfoService,
     @Inject(APP_BASE_HREF) public baseHref: string,
     private _notes:NotesHelper
  ) {
    this.memberSearchData=new MemberSearch()
  }
  ngAfterViewInit(): void {
    
  }

  async ngOnInit(): Promise<void> {
   this.User = this.webStorageService.getItemFromSessionStorage('currentUser');
   this.Company = this.webStorageService.getItemFromSessionStorage('company'); 
   this.fetchAndLoadData();
   if(this.FieldsConf && this.FieldsConf["Groups"] && (this.FieldsConf["Groups"].length<=0))
   { 
    let data:any =await this.configService.readFileContent('/assets/member-info-fields.json');
    this.loaderService.display(false) 
    if(data && data.length>0){ 
      this.fieldDetails=data
    }
   }
  }

  fetchAndLoadData()
  {
    this.memberSearchData=this.additionalinfoService.getMemberSearchData();
    if(!this.memberSearchData){
      this.memberSearchData=new MemberSearch();
    }
    this.MemberData=this.additionalinfoService.getMemberTabularData();
    let memberInfoData=this.additionalinfoService.getMemberInfoData();
    if(memberInfoData)
    {
      this.showTabularData=false;
      this.displayMemberInfo=true;
      this.mapMemberDetails(memberInfoData);
    }
    else if(this.MemberData){
      if(this.MemberData.length>1)
      {
        this.displayMemberInfo=false;
        this.showTabularData=true;
      }
    }
  }
  clearSearchResults()
  {
    this.displayMemberInfo=false;
    this.showTabularData=false;
    this.memberSearchData=new MemberSearch();
    this.additionalinfoService.setMemberInfoData(null);
    this.additionalinfoService.setMemberTabularData(null);
    this.additionalinfoService.setMemberSearchData(null);
  }
  memberInfoSearchPayload(searchData)
  {
    let payload:any={}
    payload.method='GetMember';
    payload.user=this.User;
    payload.company=this.Company;
    payload.parameters=searchData;
    payload.parameters.DateOfBirth=searchData?.DateOfBirth?this.additionalinfoService.getFormattedDate(searchData?.DateOfBirth):'';
    return payload;
  }

  MemberInfoSearchData():boolean{
    if(this.memberSearchData.CarrierMemberId.trim()=='' && this.memberSearchData.Name.trim()=='')
    {
      return false;
    }
    return true;
  } 
  async search()
  {
    this.displayMemberInfo=false;
    let dataAvailable:boolean=this.MemberInfoSearchData();
    if(dataAvailable){ 
    this.additionalinfoService.getAdditionalInfo(this.memberInfoSearchPayload(this.memberSearchData)).subscribe(memberInfoData=>{
      if(memberInfoData && "Response" in memberInfoData && "Status" in memberInfoData["Response"] && memberInfoData["Response"]['Status']==1){ 
        if(memberInfoData && "Response" in memberInfoData && "Data" in memberInfoData["Response"]&&memberInfoData["Response"]['Data']){
            this.MemberData=JSON.parse(memberInfoData["Response"]["Data"]);
            this.currentpage=0;
            this.additionalinfoService.setMemberSearchData(this.memberSearchData); 
            if(this.memberSearchData.CarrierMemberId && this.memberSearchData.CarrierMemberId.trim()!='')
            {
              this.displayMemberInfo=true;
              this.additionalinfoService.setMemberInfoData(this.MemberData)
              this.mapMemberDetails(this.MemberData);
              
            }
            else{
              this.additionalinfoService.setMemberTabularData(this.MemberData)
              this.showTabularData=true;
            }
          }
        else
          {
            this.showModalDialog("No records found for the provided search criteria.");
          }
      }
      else
      {
        this.showModalDialog("No records found for the provided search criteria.");
      }
    }); 
    }
    else{
      this.showModalDialog("Please enter a valid Carrier Member Id and/or Name.");
    }
    
  }
  showModalDialog(messageText)
  {
    const initialState = { message:messageText};
    const config: ModalOptions = { class: 'modal-sm modal-dialog-centered', ignoreBackdropClick:true, keyboard:false ,initialState:initialState};
    this.modalRef = this.modalService.show(MessageDialogComponent,config);
   // this.modalRef.content.event.subscribe((result: any) => {});
  }
  mapMemberInfoFieldValues(memberInfoData)
  {
    this.FieldsConf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        field["value"] = memberInfoData[0][field["Name"]];
      });
    });

    let temp=this.FieldsConf.Groups[0].Fields.filter(field=>field.Name=='FullName') ;
      if(temp &&temp.length>0)
      {
        this.MemberName=temp[0]['value']
      }
  } 
  private mapMemberDetails(memberInfoData): void {
    const member = memberInfoData[0] ?? {}; 
    this.mappedDetails = this.fieldDetails.reduce((acc, field) => { 
      acc[field.label] = this._notes.isEmptyOrWhitespace(member[field.key])?'': this._notes.parsefromContent(member[field.key]);
      if (field.key === 'FullName') {
        this.MemberName = member[field.key] ?? '';
      }
      return acc;
    }, {} as Record<string, string>);
  }
  checkDate(newDate:any)
  {
    //console.log("newDate:"+newDate)
  }
  sortByName()
  {
    if(this.sortOrder==='Asc')
    {
      this.MemberData.sort((a,b)=>a.Name.localeCompare(b.Name))
    }
    else
    {
      this.MemberData.sort((a,b)=>b.Name.localeCompare(a.Name))
    }
    this.sortOrder=this.sortOrder=='Asc'?'Desc':'Asc'
    }
    
  async getMemberInfo(filePath)
  {
    let InfoData:any=await this.configService.readFileContent('/assets/sampleResponse.json')
    this.loaderService.display(false)
    if(InfoData && "Response" in InfoData && "Data" in InfoData["Response"]){
      return JSON.parse(InfoData["Response"]["Data"]);
    }
    return []
  }
  onRowSelect(event:any)
  {
    let memberInfoData:any; 
    let memberdata={MemberId:event.data.MemberId}
    this.additionalinfoService.getAdditionalInfo(this.memberInfoSearchPayload(memberdata)).subscribe(memberInfoData=>{
       
      if(memberInfoData && "Response" in memberInfoData && "Status" in memberInfoData["Response"] && memberInfoData['Response']['Status']==1){
        if(memberInfoData && "Response" in memberInfoData && "Data" in memberInfoData["Response"]){
          let MemberInfo:any=JSON.parse(memberInfoData["Response"]["Data"]);
          this.additionalinfoService.setMemberInfoData(MemberInfo) 
          if(MemberInfo.length>0)
          {
            this.showTabularData=false
            this.displayMemberInfo=true;
            this.mapMemberDetails(MemberInfo);
            this.additionalinfoService.setMemberInfoData(MemberInfo)
          }
        }
      }
      else{
        this.showModalDialog("Failed to fetch details for selected record.");
      }
    })
  }

  navBack()
  {
    this.showTabularData=true;
    this.displayMemberInfo=false
    this.additionalinfoService.setMemberInfoData(null)
  }

  onPageChange(event)
  { 
  } 
}

class MemberSearch{
  Name:string="";
  CarrierMemberId:string=""
  Email:string=""
  DateOfBirth:Date;
}